<template>
  <div class="progress-bar">
    <div :style='{width: progressWidth, backgroundColor: color}' :class="['progress']" :value="value" max="100"></div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    value: {type: Number, default: 0},
    color: {type: String, default: '#3377ee'}
  },
  computed: {
    progressWidth () {
      return Math.round(this.value * 100, 2) + '%';
    }
  }
}
</script>

<style lang='scss' scoped>
  .progress-bar {
    background-color: #efefef;
    width:100%;
    height:5px;
    border-radius: 5px;
    .progress {
      height:100%;
      border-radius: 5px;
    }
    & > div {
      background-color: #888888;
    }
  }
</style>